import { filter, ignoreElements, tap, take } from 'rxjs/operators';

import { loadConfigSuccess } from '../../../app/reducers';
import { RootEpic } from '../../../store/epics';

export const statsigEpic: RootEpic = (action$, _state$, { api: { statsig } }) =>
  action$.pipe(
    filter(loadConfigSuccess.match),
    take(1),
    tap(({ payload: { statsig: statsigConfig } }) => {
      statsig.loadStatsigSidecar(statsigConfig.clientKey);
      statsig.initializeStatsigSessionReplay(statsigConfig.clientKey);
    }),
    ignoreElements(),
  );
